<div class="app-http-error">
  <div class="app-http-error__card">
    <div class="app-http-error__icon">
      <i class="fa fa-frown-o" aria-hidden="true"></i>
    </div>
    <h1 class="app-http-error__detail">{{ errorDetail | abpLocalization }}</h1>
    <div class="app-http-error__actions">
      <a (click)="destroy$.next()" routerLink="/" class="btn btn-primary">
        <i class="fa fa-home me-1"></i>{{ 'AbpUi::GoHomePage' | abpLocalization }}
      </a>
      <a href="javascript:void(0)" class="btn btn-outline-secondary" (click)="goBack()">
        <i class="fa fa-long-arrow-left me-1"></i>{{ 'AbpUi::GoBack' | abpLocalization }}
      </a>
    </div>
    <a href="javascript:void(0)" class="app-http-error__logout" (click)="logout()">
      <i class="fa fa-sign-out me-1"></i
      >{{ { key: 'AbpUi::Logout', defaultValue: 'Log out' } | abpLocalization }}
    </a>
  </div>
</div>
